'use client';
import { useEffect } from 'react';
import useAddItemHistory from '@//data/item-history/useAddItemHistory';

interface ActivityTrackerProps {
  id: string;
}

const ActivityTracker = ({ id }: ActivityTrackerProps) => {
  const addItemHistory = useAddItemHistory();

  useEffect(() => {
    addItemHistory.mutate({
      id,
      date: new Date().toISOString(),
    });
  }, [id]);

  return null;
};

export default ActivityTracker;
